import type { IconData } from '@stacksjs/iconify-core'

export const borderHorizontal: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M40 240h432v32H40zm400 200h32v32h-32zm-133.818 0h33.455v32h-33.455zm-133.818 0h33.455v32h-33.455zm200.727 0h33.455v32h-33.455zm-267.636 0h33.455v32h-33.455zM40 440h32v32H40zm0-133.817h32v33.454H40zm0 66.909h32v33.454H40zm0-200.728h32v33.454H40zm0-66.909h32v33.454H40zM40 40h32v32H40zm266.182 0h33.455v32h-33.455zm-133.818 0h33.455v32h-33.455zm200.727 0h33.455v32h-33.455zm-133.819 0h33.455v32h-33.455zm-133.817 0h33.455v32h-33.455zM440 40h32v32h-32zm0 333.091h32v33.454h-32zm0-66.909h32v33.454h-32zm0-200.728h32v33.454h-32zm0 66.909h32v33.454h-32zM239.272 306.182h33.455v33.454h-33.455zm0-133.819h33.455v33.454h-33.455zm0-66.909h33.455v33.454h-33.455zm0 267.637h33.455v33.454h-33.455zm0 66.909h33.455v32h-33.455z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default borderHorizontal
